import { Badge } from '@ui/components/Badge';

type Props = {
  tournament?: {
    rcfRankCalculated: boolean;
    orgSettings?: {
      organizer: string | null;
      chiefArbiter: string | null;
      arbiters: string[] | null;
    };
  };
};

export function TournamentOrgBadges({ tournament }: Props) {
  if (!tournament || !tournament.orgSettings || !tournament.rcfRankCalculated) return null;

  const people = [];
  if (tournament.orgSettings.chiefArbiter)
    people.push('Главный арбитр: ' + tournament.orgSettings.chiefArbiter);
  if (tournament.orgSettings.organizer)
    people.push('Организатор: ' + tournament.orgSettings.organizer);
  if (tournament.orgSettings.arbiters) {
    tournament.orgSettings.arbiters.forEach((a) => {
      people.push('Судья: ' + a);
    });
  }

  return (
    <>
      {people.map((p) => (
        <Badge flat size="m" key={p}>
          {p}
        </Badge>
      ))}
    </>
  );
}
